import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    routerkey:'',
    webConfig:'',
    token: '',
    tabbarActive:0,
    user:'',
    show:{
      video:true,
      image:true,
      news:true,
    },
    webWidth:document.documentElement.clientWidth
  },
  mutations: {
    refreshRouterKey(state){
      state.routerkey = new Date().getTime();
    },
    setTabbarActive(state, $path) {
      state.tabbarActive = 0;
      if ($path == "/index/user") {
        state.tabbarActive = 2;
      }
      if ($path == "/index/tool") {
        state.tabbarActive = 1;
      }  
    },
    setWebConfig(state, $data){
      state.webConfig=$data
    },
    setToken(state, $token){//登录时候执行方法手动写入token
      state.token=$token;
      localStorage.setItem('token',$token);
    },
    autoSetToken(state){//登录时候执行方法自动获取localStorage的token
      var $token = localStorage.getItem('token');
      state.token = $token;
    },
    removeToken(state){
      state.token='';
      localStorage.removeItem('token');
    
    },
    setUserData(state,$data){
     // console.log($data);
      state.user=$data;
     // console.log('state',state.user);
    },
    setLocal(state, $key, $val) {
      return localStorage.setItem($key, $val);
    }, getLocal(state, $key) {
      return localStorage.setItem($key);
    }, removeLocal(state, $key) {
      return localStorage.removeItem($key);
    }
  },
  getters: {
    token: state => {
      return state.token;
    },
    setToken: state => {
      var $token = localStorage.getItem('token');
      return state.token = $token; 
    },
  }
})
export default store